// extracted by mini-css-extract-plugin
export default {"icon-button":"AddButton_icon-button__S55Jv"};